/**
 * Collection Finish Switcher
 * Switches all product card images to show a selected finish variant.
 */
(function () {
  var SELECTOR = {
    switcher: '[data-finish-switcher]',
    swatch: '[data-finish-swatch]',
    gridItem: 'product-grid-item',
    variant: 'product-grid-item-variant',
    variantAttr: 'data-grid-item-variant',
    finishMap: 'data-finish-map',
    swatchLink: 'a[data-grid-item-variant]'
  };

  var STORAGE_KEY = 'wallware-finish';

  function init() {
    var switchers = document.querySelectorAll(SELECTOR.switcher);
    if (!switchers.length) return;

    // Restore saved finish preference across all switcher instances
    var saved = getSavedFinish();
    if (saved) {
      syncAllSwitchers(saved);
      switchAllCards(saved);
    }

    switchers.forEach(function (switcher) {
      switcher.querySelectorAll(SELECTOR.swatch).forEach(function (swatch) {
        swatch.addEventListener('click', function () {
          var finish = swatch.getAttribute('data-finish-value');
          syncAllSwitchers(finish);
          switchAllCards(finish);
          saveFinish(finish);
        });
      });
    });

    observeGrid();
  }

  function syncAllSwitchers(finish) {
    document.querySelectorAll(SELECTOR.swatch).forEach(function (s) {
      if (s.getAttribute('data-finish-value') === finish) {
        s.setAttribute('aria-checked', 'true');
      } else {
        s.setAttribute('aria-checked', 'false');
      }
    });
  }

  function getSavedFinish() {
    try { return localStorage.getItem(STORAGE_KEY); } catch (e) { return null; }
  }

  function saveFinish(finish) {
    try { localStorage.setItem(STORAGE_KEY, finish); } catch (e) { /* silent */ }
  }

  function switchAllCards(finish) {
    var gridItems = document.querySelectorAll(SELECTOR.gridItem);
    gridItems.forEach(function (item) {
      var mapAttr = item.getAttribute(SELECTOR.finishMap);
      if (!mapAttr) return;

      var finishMap;
      try {
        finishMap = JSON.parse(mapAttr);
      } catch (e) {
        return;
      }

      var targetVariantId = finishMap[finish];
      if (!targetVariantId) return;

      // Toggle variant visibility (same mechanism as per-card swatches)
      var variants = item.querySelectorAll(SELECTOR.variant + '[' + SELECTOR.variantAttr + ']');
      variants.forEach(function (v) {
        var vid = v.getAttribute(SELECTOR.variantAttr);
        if (vid === String(targetVariantId)) {
          v.removeAttribute('hidden');
          // Eager-load images in the newly visible variant
          v.querySelectorAll('product-grid-item-image').forEach(function (img) {
            img.setAttribute('loading', 'eager');
          });
        } else {
          v.setAttribute('hidden', '');
        }
      });

      // Update per-card swatch aria-current to match
      var cardSwatches = item.querySelectorAll(SELECTOR.swatchLink);
      cardSwatches.forEach(function (link) {
        var linkVariant = link.getAttribute(SELECTOR.variantAttr);
        if (linkVariant === String(targetVariantId)) {
          link.setAttribute('aria-current', 'true');
        } else {
          link.removeAttribute('aria-current');
        }
      });
    });
  }

  function observeGrid() {
    var grid = document.querySelector('[data-products-grid]');
    if (!grid) return;

    var observer = new MutationObserver(function () {
      var activeSwatch = document.querySelector(SELECTOR.swatch + '[aria-checked="true"]');
      if (activeSwatch) {
        var finish = activeSwatch.getAttribute('data-finish-value');
        switchAllCards(finish);
      }
    });

    observer.observe(grid, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
